var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_121b01b8"]},_vm.$listeners),[_c('cube-button',{attrs:{"open-type":"chooseAvatar","tip":"需在微信小程序环境预览"},on:{"chooseAvatar":(e)=>_vm.__invoke(e, [["onChooseAvatar"]])}},[_vm._v("获取头像")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }